import { render } from "./MainJaLayout.vue?vue&type=template&id=604a8677"
import script from "./MainJaLayout.vue?vue&type=script&lang=js"
export * from "./MainJaLayout.vue?vue&type=script&lang=js"

import "./MainJaLayout.vue?vue&type=style&index=0&id=604a8677&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__